import React from 'react';
import { BsLinkedin, BsTwitter } from 'react-icons/bs';
import { TfiEmail } from 'react-icons/tfi';
import { TiPhoneOutline } from 'react-icons/ti';

const Contact = () => {
  return (
    <footer id="Contact" className="section-wrap contact-section">
      <div className="contact-card">
        <p className="eyebrow">Contact</p>
        <h2 className="section-title">Let&apos;s build something great.</h2>

        <div className="contact-grid">
          <a href="mailto:ryanolee11@gmail.com" className="contact-item">
            <TfiEmail />
            <span>ryanolee11@gmail.com</span>
          </a>
          <a href="tel:+15185709021" className="contact-item">
            <TiPhoneOutline />
            <span>518-570-9021</span>
          </a>
          <a href="https://www.linkedin.com/in/ryan-lee-a50262139" target="_blank" rel="noreferrer" className="contact-item">
            <BsLinkedin />
            <span>LinkedIn</span>
          </a>
          <a href="https://twitter.com/Ryan_O_Lee" target="_blank" rel="noreferrer" className="contact-item">
            <BsTwitter />
            <span>Twitter</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Contact;
